import { MtDriveFile, MtDriveVersion } from "server/models"
import { inferLiteral, StateType } from "client/utils"
import * as types from "./types"

export const setCcReviewDocumentBaseRoute = (baseRoute: string) => ({
    type: inferLiteral(types.CC_REVIEW_DOCUMENT_BASE_ROUTE),
    baseRoute,
})
export const setCcReviewDocumentActiveTab = (activeTab: string) => ({
    type: inferLiteral(types.CC_REVIEW_DOCUMENT_ACTIVE_TAB),
    activeTab,
})
export const setCcReviewDocumentFileList = (fileList: MtDriveFile[]) => ({
    type: inferLiteral(types.CC_REVIEW_DOCUMENT_FILE_LIST),
    fileList,
})
export const setCcReviewDocumentActiveFile = (file: MtDriveFile) => ({
    type: inferLiteral(types.CC_REVIEW_DOCUMENT_ACTIVE_FILE),
    file,
})
export const setCcReviewDocumentActiveVersion = (version: MtDriveVersion) => ({
    type: inferLiteral(types.CC_REVIEW_DOCUMENT_ACTIVE_VERSION),
    version,
})
export const setCcReviewDocumentLoadState = (state: StateType) => ({
    type: inferLiteral(types.CC_REVIEW_DOCUMENT_LOAD_STATE),
    state,
})
